import React from "react";
import { Signal, Wifi, Battery, MessageCircle } from "lucide-react";
import { AbasAtendimento, LinhaBusca, ItemConversa } from "./ListaConversas";
import { CORES, CONVERSAS } from "./dadosMockup";

export const CELULAR_LARGURA = 280;
export const CELULAR_ALTURA = 620;

/**
 * Versao mobile do produto: a coluna de conversas real (abas, busca, contatos
 * com canal) dentro de um celular. Moldura inspirada no Celular() do
 * MockupWebMobile.
 */
export default function CelularAtendimento() {
  return (
    <div
      className="relative rounded-[44px] p-[7px]"
      style={{
        width: CELULAR_LARGURA,
        height: CELULAR_ALTURA,
        background: "linear-gradient(135deg, #292929, #111111 45%, #000)",
        border: "1px solid rgba(255,255,255,0.15)",
        boxShadow: "0 40px 80px -30px rgba(0,0,0,0.9), 0 0 60px -10px rgba(34,197,94,0.12)",
      }}
    >
      {/* botoes laterais */}
      <div className="absolute -left-[3px] top-[26%] w-[3px] h-[36px] rounded-l bg-[#242424] border border-white/10" />
      <div className="absolute -right-[3px] top-[22%] w-[3px] h-[52px] rounded-r bg-[#242424] border border-white/10" />

      <div className="relative w-full h-full rounded-[37px] overflow-hidden flex flex-col" style={{ background: CORES.card, border: "1px solid rgba(255,255,255,0.1)" }}>
        {/* status bar + notch */}
        <div className="relative flex items-center justify-between px-6 pt-3 pb-1.5 shrink-0">
          <span className="text-white text-[11px] font-semibold">17:32</span>
          <div className="absolute left-1/2 -translate-x-1/2 top-2.5 w-[72px] h-[18px] rounded-full bg-black border border-white/5" />
          <div className="flex items-center gap-1 text-white">
            <Signal className="w-3 h-3" />
            <Wifi className="w-3 h-3" />
            <Battery className="w-3.5 h-3.5" />
          </div>
        </div>

        <div className="flex flex-col gap-2.5 px-3 pt-2 min-h-0">
          <div className="flex items-center gap-1.5 px-1">
            <MessageCircle className="w-4 h-4" style={{ color: CORES.primary }} />
            <span className="text-sm font-bold" style={{ color: CORES.texto }}>Chat</span>
          </div>
          <AbasAtendimento compacta />
          <LinhaBusca compacta />
          <div className="h-px" style={{ background: CORES.muted }} />
          <div className="flex flex-col gap-1">
            {CONVERSAS.slice(0, 6).map((c) => (
              <ItemConversa key={c.nome} conversa={c} compacta />
            ))}
          </div>
        </div>

        {/* home indicator */}
        <div className="mt-auto flex justify-center pb-2 pt-1">
          <div className="w-[88px] h-[4px] rounded-full bg-white/25" />
        </div>
      </div>
    </div>
  );
}
